// extracted by mini-css-extract-plugin
export default {"container":"HeadingWithTooltip_container__9C+gc","tooltipWrapper":"HeadingWithTooltip_tooltipWrapper__gVokc"};